
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService } from '../../../xform-compat';
import { MyCompany, RmsSearch } from '../../../shared/models';


/**
 * Data service for searching and filtering companies
 */
@Injectable({
  providedIn: 'root'
})
export class MyCompanySearchService implements RmsSearch<MyCompany> {

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService
  ) { }

  /**
   * Searches in the followed list of my companies
   * @param {string} term
   * @returns {Observable<MyCompany>}: new list returned from the API
   */
  search(term: string): Observable<MyCompany> {
    const url = `/api/rms/companies/follow/me?name=${term}`;
    return this.http.get(url).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Searches in the non following companies
   * @param {string} term
   * @returns {Observable<MyCompany>}: New list returned from the API
   */
  public filterUnFollowedCompanies (term: string): Observable<MyCompany> {
    const url = `/api/rms/companies/unfollow/me?name=${term}`;
    return this.http.get(url).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
